import {Component, Input} from "@angular/core";
import {AuthService} from "../../../../services/auth.service";
import {RootShareService} from "../../../../services/root.shared.service";
import {PatientGeneralHistory} from "../../../../models/forms/referral/patient.general.history";
import {VteStage1} from "../../../../models/forms/vte/vte.stage1";
import {VteStage2} from "../../../../models/forms/vte/vte.stage2";
import * as _ from 'lodash';

@Component({
    selector: 'vte-stage2-component',
    templateUrl: './vte.stage2.html'
})
export class VteStage2Component {
    @Input() stage2: VteStage2;

    @Input() patient: any;
    @Input() patientDocument: any;
    @Input() readOnly: Boolean = false;

    constructor(private _rootShareService: RootShareService, private _auth: AuthService) {
    }

    clickQ(qn) {
        if (!this.readOnly)
            this.stage2[qn] = !this.stage2[qn];
    }
}
